module.exports = __webpack_public_path__ + "img/tick_white.5fa1ba61.svg";